import { render } from "./UploadName.vue?vue&type=template&id=009193d4"
import script from "./UploadName.vue?vue&type=script&lang=js"
export * from "./UploadName.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__